import React from 'react';

export const Blur: React.FC = () => <div className="blur" />;
